import React, { useContext } from "react";
import styles from '../../individualWorkPlan.module.css';
import { IndividualWorkPlanContext } from "../../../../utils/context";
import { useState } from "react";
import AcademicWorkTable from "./AcademicWorkRow";
import AcademicWorkRow from "./AcademicWorkRow";


export default function AcademicWork() {

  const { id, filteredItemsAcademicWork, academicWorkGroup } = useContext(IndividualWorkPlanContext)

  const body = (Object.entries(filteredItemsAcademicWork).filter(([key, value]) => key.length !== 0))

  return (
    <>
      <div className="table">

        <p>Распределение времени по семестрам и основным видам деятельности</p>
        <table className="tg-second">
          <thead>
            <tr>
              <th className="tg-yw4l" rowSpan={3}>№ п/п</th>
              <th className="tg-yw4l" rowSpan={3} style={{ width: '300px' }}>Основные виды деятельности</th>
              <th className="tg-yw4l" colSpan={9}>Объем деятельности в часах</th>
            </tr>
            <tr>
              <th className={styles.table23} colSpan={3}>I семестр</th>
              <th className={styles.table23} colSpan={3}>II семестр</th>
              <th className={styles.table23} colSpan={3}>Учебный год</th>
            </tr>
            <tr>
              <th className={styles.table23}>уч. группы</th>
              <th className={styles.table23}>по плану</th>
              <th className={styles.table23}>выполнено</th>
              <th className={styles.table23}>уч. группы</th>
              <th className={styles.table23}>по плану</th>
              <th className={styles.table23}>выполнено</th>
              <th className={styles.table23}>по плану</th>
              <th className={styles.table23}>выполнено</th>
            </tr>
          </thead>
          <tbody>
            {body?.map((el, i) => {
              let col = 1
              const rows = el[1].map(row =>
                row.razdel === el[0] &&
                (col = col + 1,
                  <AcademicWorkRow item={row} academicWorkGroup={academicWorkGroup} />
                )
              )



              return (
                <>
                  < tr style={{ backgroundColor: '#a45c5c' }} >
                    <td rowSpan={col}>{i + 1}</td>
                    <td >{el[0]}</td>
                    <td ></td>
                    <td ></td>
                    <td ></td>
                    <td ></td>
                    <td ></td>
                    <td ></td>
                    <td ></td>
                    <td ></td>
                    {/* <td >{groupnames1}</td>
                    <td>{plan_1}</td>
                    <td>{fact_1}</td>
                    <td>{groupnames2}</td>
                    <td>{plan_2}</td>
                    <td>{fact_2}</td>
                    <td>{s_fact}</td>
                    <td>{s_plan}</td> */}
                  </tr >
                  {rows}
                </>

              )
            }
            )
            }
          </tbody>

        </table>
        {/* ) : (
            <NoData text="данные отсутствуют" />
          )} */}
      </div >
      {!filteredItemsAcademicWork && <div className="div__buttons">
        <div className="buttons__edit">Изменить</div>

      </div>
      }
    </>
  );
}
